import localDB from "./localDB";

let GLOBAL = require('./globals');

const ChangelogData = {
    async list(search, page) {
        let response = await fetch(`${GLOBAL.BASE_URL}api/change-logs?search=${search}&page=${page}`, {
            method: 'GET',
            headers: {
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json();
    },
    async readAll() {
        let response = await fetch(`${GLOBAL.BASE_URL}api/change-logs/read-all-notifications`, {
            method: 'GET',
            headers: {
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json();
    },
};

export default ChangelogData;


// WEBPACK FOOTER //
// ./src/data/ChangelogData.js